export const STUDY_STATUS_MESSAGES = {
  RUNNING: 'Running for ',
  FINISHED: 'Finished ',
  STARTS: 'Starts in ',
};

export function setStudyStatus(startsAt: string, endsAt: string): string {
  if (!startsAt || !endsAt) {
    return;
  }

  let status;

  const startDate = new Date(startsAt.replace(/-/g, '/'));
  const endDate = new Date(endsAt.replace(/-/g, '/'));
  const now = new Date();

  if (startDate <= now && now <= endDate) {
    status = STUDY_STATUS_MESSAGES.RUNNING + getTimeDiff(now, endDate, ' more');
  } else if (endDate < now) {
    status = STUDY_STATUS_MESSAGES.FINISHED + getTimeDiff(now, endDate) + ' ago';
  } else {
    status = STUDY_STATUS_MESSAGES.STARTS + getTimeDiff(now, startDate);
  }

  return status;
}

export function getTimeDiff(date1: Date, date2: Date, extraStr: string = '') {
  const diff = Math.abs(date1.getTime() - date2.getTime());
  const oneMinute = 1000 * 60;
  const oneHour = oneMinute * 60;
  const oneDay = oneHour * 24;

  if (diff > oneDay) {
    return Math.ceil(diff / oneDay) + extraStr + ' days';
  } else if (diff > oneHour) {
    return Math.round((diff % oneDay) / oneHour) + extraStr + ' hours';
  } else {
    return Math.round((diff % oneHour) / oneMinute) + extraStr + ' minutes';
  }
}
